// extracted by mini-css-extract-plugin
module.exports =  {"breadcrumb":"BreadcrumbItem-module__breadcrumb--Kg8yw","disabled":"BreadcrumbItem-module__disabled--w3cTW"};